exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".no-validation---1wxkC .droppable-zone::after{display:none}", ""]);

// exports
exports.locals = {
	"no-validation": "no-validation---1wxkC"
};